import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../store/actions/notificationAction';

import paymentsRemote from '../../api/paymentsRemote';
import pickupOrderRemote from '../../api/pickupOrderRemote';

import User, { UserRoleType } from '../../models/User';
import PaymentsPO from '../../models/PaymentsPO';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import PickupOrderModel from '../../models/PickupOrder';
import PickupOrderListItem from '../../models/PickupOrderListItem';

import { PO_SCHEMA } from '../../utils/pickupOrder';

import moment, { Moment } from 'moment';
import MomentUtils from "@date-io/moment";

import PickupOrder from './PickupOrder';
import ConfirmationDialog from '../confirmation/ConfirmationDialog';
import TruckDriverData from '../../models/TruckDriverData';
import deliveryCompanyRequestHandler from '../../api/deliveryCompanyRemote';

interface PickupOrderContainerProps {
  pickupOrder: PickupOrderModel;
  receiveError: Function;
  receiveSuccess: Function;
  user: User;
  showDetails: boolean;
  pickupDate: Moment;
  showTruckerInfo?: boolean;
  clearPickupDateErrorMsg?: Function;
  backToList?: boolean;
  showLine: boolean;
  userRole : UserRoleType;  type?: string;};

interface PickupOrderContainerState {
  pickupOrder: PickupOrderModel;
  editErrors: { pieces: { error: boolean, message: string }, weight: { error: boolean, message: string } };
  selectedDeliveryCompanyID: number | undefined;
  initialDeliveryCompanyID: number | undefined;
  openDockOverloadModal: boolean;
  showTruckerInfo: boolean;
  showNotify: boolean;
  pickupTimeCopy: string;
  pickupDate: Moment| string;
  pickupDateErrorMsg: string;
  payments: PaymentsPO;
  selectedDriverID: number | undefined;
  initialDriverID: number | undefined;
  isDeleteLastAwbModalOpened: boolean;
  deleteLastAwbModalCallback: Function;
  sendOrder: string;
  deleteOrder: boolean;
};

class PickupOrderContainer extends Component<PickupOrderContainerProps, PickupOrderContainerState> {

  state = {
    pickupOrder: PO_SCHEMA,
    editErrors: {
      pieces: { error: false, message: '' },
      weight: { error: false, message: '' }
    },
    selectedDeliveryCompanyID: undefined,
    initialDeliveryCompanyID: undefined,
    selectedDriverID: undefined,
    initialDriverID: undefined,
    openDockOverloadModal: false,
    showTruckerInfo: true,
    showNotify: false,
    pickupTimeCopy: '',
    pickupDate: new MomentUtils().date(),
    pickupDateErrorMsg: '',
    payments: {
      totalDue: 0,
      totalPending: 0,
      payments: []
    },
    isDeleteLastAwbModalOpened: false,
    deleteLastAwbModalCallback: () => {},
    sendOrder: 'truckingCompany',
    deleteOrder: false
  }

  load = (): void => {
    const pickupDate: Moment | string = this.props.pickupOrder.pickup_date ? this.props.pickupOrder.pickup_date : new MomentUtils().date();
    const selectedDeliveryCompanyID: number | undefined = this.props.pickupOrder.id_delivery_company ? this.props.pickupOrder.id_delivery_company : undefined;
    
    this.setState({ 
      pickupOrder: this.props.pickupOrder, pickupDate, selectedDeliveryCompanyID });
  };

  componentDidMount() {
    this.load();
    this.getPendingPayments(this.props.pickupOrder.list);
  }

  componentDidUpdate(prevProps: PickupOrderContainerProps) {

    if (prevProps.pickupOrder !== this.props.pickupOrder ) {
      this.load();
     if( this.props.pickupOrder.list.length > 0) {
      this.getPendingPayments(this.props.pickupOrder.list);
    }
  }
  }

  getPendingPayments = (items: Array<PickupOrderListItem>): void => {
    
    const awbs: Array<{ code: string; number: string; version: number }> = [];

    for (const awb of items) {
      awbs.push({ code: awb.code, number: awb.number, version: awb.version });
    };

    paymentsRemote.getPoPayments(awbs, 'pending').then((resp: ApiResponse<PaymentsPO>) => {

      const payments: PaymentsPO | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (payments) {
        this.setState({ payments });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  setContainerState = (data: any): void => {
    this.setState(data);
  }

  handleFieldsInput = (fieldName: string, event: any): void => {

    const currentPO: PickupOrderModel = { ...this.state.pickupOrder };
    const value: string = event.target.value;

    switch (fieldName) {

      case 'bill_to': currentPO.bill_to.full_address = value; break;
      case 'deliver_to':
        currentPO.deliver_to = currentPO.deliver_to || {};
        currentPO.deliver_to.full_address = value; 
        break;
      case 'endorse_to':
        currentPO.endorse_to = currentPO.endorse_to || {}; 
        currentPO.endorse_to.full_address = value; 
        break;
      case 'pickup_from': currentPO.pickup_from.full_address = value; break;
      case 'poAdditionalInformation':
        currentPO.additional_info = value; 
        break;
      default: break;
    }

    this.setState({ pickupOrder: currentPO });
  }

  handleSetDeliveryCompanyID = (deliveryCompanyID: number): void => {

    let delCompanyID: number | undefined = undefined ;
    
    if (deliveryCompanyID) {
      delCompanyID = deliveryCompanyID
    };

    const po: PickupOrderModel = { ...this.state.pickupOrder };
    po.id_delivery_company = delCompanyID;

    this.setState({ pickupOrder: po, selectedDeliveryCompanyID: delCompanyID, showTruckerInfo: false });
  };

  maskon = () => {
    const currentPO: PickupOrderModel = { ...this.state.pickupOrder };
    currentPO.maskedDriverId =  currentPO.driver_id.replace(/.(?=.{4,}$)/g, '#');
    this.setState ({ pickupOrder: currentPO });
  }

  handleClick = (event: any) => {
    const currentPO: PickupOrderModel = { ...this.state.pickupOrder };
    currentPO.maskedDriverId =  currentPO.driver_id;
    this.setState({ pickupOrder: currentPO });
  }

  handleSelectPickUpTime = (): void => {
    this.setState({ openDockOverloadModal: true });
  }

  submitPickupOrder = (): void => {

    const po: PickupOrderModel = { ...this.state.pickupOrder };
    po.id_delivery_company = this.state.selectedDeliveryCompanyID === 0 ? undefined : this.state.selectedDeliveryCompanyID;

    if (this.state.showTruckerInfo === false) {
      po.driver_name = '';
      po.driver_id = '';
      po.driver_id_type = '';
      po.driver_vehichle_registration = '';
      po.rfs_number = '';
      po.driver_contact = '';
    }
    let direct = this.state.sendOrder === 'driver' ? true : false;

    pickupOrderRemote.updatePickupOrder(po, direct).then((resp: ApiResponse<PickupOrderModel>) => {

      const po: PickupOrderModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (po) {

        this.setState({
          pickupOrder: po,
          selectedDeliveryCompanyID: po.id_delivery_company,
          showNotify: true
        });

        this.clearPickupDateErrorMsg();
        this.props.receiveSuccess('The PO has been successfully updated!');
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  handleCloseDockOverloadModal = (time: string): void => {

    if (time) {

      const setTime: string = time.replace('.', '');
      const currentPO: PickupOrderModel = { ...this.state.pickupOrder };
      
      currentPO.pickup_time = setTime;
      this.setState({ pickupOrder: currentPO });
    };

    this.setState({ openDockOverloadModal: false });
  };

  handleSetDriverID = (driverId: number): void => {

    let truckDriverId: number | undefined = undefined ;
    
    if (driverId) {
      truckDriverId = driverId;
    };

    const po: PickupOrderModel = { ...this.state.pickupOrder };
    po.id_driver = truckDriverId;
    deliveryCompanyRequestHandler.getDriverById(driverId).then((resp: ApiResponse<TruckDriverData>) => {

      const truckDriver: TruckDriverData | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (truckDriver) {
        po.delivery_company_name = truckDriver.company;
        po.driver_vehichle_registration = truckDriver.plate;
        po.driver_id = truckDriver.license;
        po.maskedDriverId =  po.driver_id ? po.driver_id.replace(/.(?=.{4,}$)/g, '#') : po.driver_id;
      }
      this.setState({ pickupOrder: po, selectedDriverID: truckDriverId, showTruckerInfo: false });

      if (error) {
        this.props.receiveError(error);
      };
    });

  };

  hideTruckerInfo = (): void => {

    this.setState({ showTruckerInfo: false });
  }

  resetPickupTime = (): void => {

    const currentPO: PickupOrderModel = { ...this.state.pickupOrder };
    const pickupTimeCopy: string = currentPO.pickup_time;
    currentPO.pickup_time = '';

    this.setState({ pickupOrder: currentPO, pickupTimeCopy });
  }

  changedDriver = (newDriverID: number): void => {

    const currentPO: PickupOrderModel = { ...this.state.pickupOrder };

    if (this.state.pickupTimeCopy !== '') {
      currentPO.pickup_time = this.state.pickupTimeCopy;
    };
    currentPO.id_driver = newDriverID
    deliveryCompanyRequestHandler.getDriverById(newDriverID).then((resp: ApiResponse<TruckDriverData>) => {

      const truckDriver: TruckDriverData | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (truckDriver) {
        currentPO.delivery_company_name = truckDriver.company;
        currentPO.driver_vehichle_registration = truckDriver.plate;
        currentPO.driver_id = truckDriver.license;
        currentPO.maskedDriverId =  currentPO.driver_id ? currentPO.driver_id.replace(/.(?=.{4,}$)/g, '#') : currentPO.driver_id;
      }
      this.setState({
        selectedDriverID: newDriverID,
        pickupOrder: currentPO,
        showNotify: false
      });
      if (error) {
        this.props.receiveError(error);
      };
    });

  };

  changedDeliveryCompany = (newDeliveryCompanyID: number): void => {

    const currentPO: PickupOrderModel = { ...this.state.pickupOrder };
    const sameDeliveryCompanyID: boolean = this.state.pickupOrder.id_delivery_company === newDeliveryCompanyID;

    if (this.state.pickupTimeCopy !== '') {
      currentPO.pickup_time = this.state.pickupTimeCopy;
    }

    this.setState({
      selectedDeliveryCompanyID: newDeliveryCompanyID,
      showTruckerInfo: sameDeliveryCompanyID,
      pickupOrder: currentPO,
      showNotify: false
    });
  }

  changeDriverDetails = (type: string, event: any): void => {

    const pO: PickupOrderModel = { ...this.state.pickupOrder };
    const value: string = event.target.value;
    switch(type) {
      case 'license' :
        pO.driver_id = value;
        this.setState({ pickupOrder: pO });
        break;
      case 'plate' :
        pO.driver_vehichle_registration = value;
        this.setState({ pickupOrder: pO });
        break;
      default: break;
    }; 
  };

  changePickupDate = (type: string, date: Moment): void => {

    const po: PickupOrderModel = { ...this.state.pickupOrder };
    const currentDateStr = po.pickup_date;
    const newDateToString: string = moment(date).format('YYYYMMDD');

    if (currentDateStr !== newDateToString) {

      po.pickup_date = newDateToString;
      this.setState({ pickupOrder: po, pickupDate: date, pickupDateErrorMsg: 'The change of Pick Up date may impact the calculation of “Storage Fee”.' });
    }
  }

  clearPickupDateErrorMsg = (): void => {
    this.setState({ pickupDateErrorMsg: '' });
  }
  
  openLastAwbDeletionWarning = (callback: () => void) => {
    this.setState({isDeleteLastAwbModalOpened: true, deleteLastAwbModalCallback: () => {
      callback();
      this.setState({isDeleteLastAwbModalOpened: false, deleteOrder: true});
    }});
  }

  handleChangeSendOrder = (event: any): void => {

    const sendOrder: string = event.target.value;
    this.setState({ sendOrder})
  }

  render() {
    return (
      <Fragment>
        <PickupOrder 
          pickupOrder={ this.state.pickupOrder }
          type={ this.props.type || 'po' }
          user={ this.props.user }
          setDriverID= { this.handleSetDriverID }
          selectedDriverID= { this.state.selectedDriverID }
          changedDriver= { this.changedDriver }
          initialDriverID= { this.state.initialDriverID }
          initialDeliveryCompanyID={ this.state.initialDeliveryCompanyID }
          pickupDateErrorMsg={ this.state.pickupDateErrorMsg }
          showDetails={ this.props.showDetails }
          pickupDate={ this.state.pickupDate }
          showTruckerInfo={ this.state.showTruckerInfo }
          showNotify={ this.state.showNotify }
          backToList={ this.props.backToList }
          selectedDeliveryCompanyID={ this.state.selectedDeliveryCompanyID }
          payments={ this.state.payments }
          openDockOverloadModal={ this.state.openDockOverloadModal }
          editErrors={ this.state.editErrors }  
          handleSelectPickUpTime={ this.handleSelectPickUpTime }
          pickupDateChange={ this.changePickupDate }        
          handleFieldsInput={ this.handleFieldsInput }
          setContainerState={ this.setContainerState }
          hideTruckerInfo={ this.hideTruckerInfo }
          resetPickupTime={ this.resetPickupTime }
          handleSetDeliveryCompanyID={this.handleSetDeliveryCompanyID}
          changedDeliveryCompany={ this.changedDeliveryCompany }
          submitPickupOrder={ this.submitPickupOrder }
          handleCloseDockOverloadModal={ this.handleCloseDockOverloadModal }
          lastAwbDeletionWarning={ this.openLastAwbDeletionWarning }
          showLine={ this.props.showLine }
          sendOrder={ this.state.sendOrder}
          handleChangeSendOrder={ this.handleChangeSendOrder }
          userRole={this.props.userRole}
          changeDriverDetails={ this.changeDriverDetails }
          maskOn={ this.maskon }
          handleClick={ this.handleClick }
          deleteOrder={ this.state.deleteOrder }
        />
        { this.state.isDeleteLastAwbModalOpened && 
          <ConfirmationDialog
            open={ this.state.isDeleteLastAwbModalOpened }
            close={ () => { this.setState({ isDeleteLastAwbModalOpened: false }) } }
            title='Delete Confirmation'
            text={`You try to delete the last AWB in this Pick Up Order. \
            If you do this, the Pick Up Order will be marked with status “Deleted”. To confirm deletion, use \
            button “OK”. To cancel, use button “Cancel”.`}
            textConfirm='Ok'
            textCancel='Cancel'
            confirm={ this.state.deleteLastAwbModalCallback } 
            showCloseIcon={ true }
            showCancelButton={ true }

          />
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(PickupOrderContainer);
